import { useState, useEffect } from 'react';

export default function Tooltip({ children, text }) {
  const [visibleText, setVisibleText] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isVisible) return;

    let index = -1;
    setVisibleText('');
    const interval = setInterval(() => {
      setVisibleText((prev) => prev + text.charAt(index));
      index++;
      if (index === text.length) clearInterval(interval);
    }, 20); // typing speed

    return () => clearInterval(interval);
  }, [isVisible, text]);

  const handleMouseMove = (e) => {
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  return (
    <span
      className="tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onMouseMove={handleMouseMove}
      style={{ position: 'relative' }} // Important to scope the tooltip positioning
    >
      <span className = "live"></span>
      <span className = "meta2" id = "variableChildren">{children}</span>

      {isVisible && (
        <span
          className="tooltip-text"
          style={{
            position: 'fixed', // `fixed` is better than `absolute` when following mouse
            top: mousePos.y - 40,
            left: mousePos.x,
            pointerEvents: 'none', // So it doesn't interfere with mouse events
            zIndex: 10
          }}
        >
          <span className="typed-text">{visibleText}</span>
          <span className="blinking-caret">|</span>
        </span>
      )}
    </span>
  );
}
